<!-- netAmount number & unit select -->
<fieldset [formGroup]="form" class="in-one-column">
  <legend *ngIf="isCollection">
    {{ TITLE + "COLLECTION_UNIT" | translate }}
  </legend>
  <div class="in-one-column w-100">
    <mat-form-field>
      <app-easy-checkbox
        formControlName="withDepositFee"
        [label]="TITLE + 'DEPOSITE_FEE' | translate"
        (ngModelChange)="changeDepositFee($event)"
      ></app-easy-checkbox>
    </mat-form-field>
  </div>
  <div class="in-two-columns w-100">
    <mat-form-field>
      <app-easy-select
        [label]="
          TITLE + (isCollection ? 'COLLECTION_TYPE' : 'PACKAGING_UNIT_TYPE')
            | translate
        "
        formControlName="packingMethodSubType"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [hasEmptyOption]="false"
        [options]="
          subtypes
            | toSelectOption
              : (form.value.withDepositFee ? 'CONTAINERS' : 'PACKAGING') +
                  '.NEW.SUBTYPE.' +
                  form.value.mainType +
                  '.'
        "
        [translatePrefixForSelected]="
          (form.value.withDepositFee ? 'CONTAINERS' : 'PACKAGING') +
          '.NEW.SUBTYPE.' +
          form.value.mainType +
          '.'
        "
        (ngModelChange)="onSubtypeChange($event)"
      ></app-easy-select>
    </mat-form-field>

    <mat-form-field *ngIf="form.value.packingMethodSubType">
      <app-easy-select
        [label]="
          TITLE + (isCollection ? 'COLLECTION' : 'PACKAGING_UNIT_NAME')
            | translate
        "
        formControlName="refId"
        [options]="
          ((isCollection
            ? collectionPackagingUnits$
            : standalonePackagingUnits$
          ) | async) ?? []
        "
        [labelAttribute]="'name'"
        [valueAttribute]="'id'"
      >
      </app-easy-select>
    </mat-form-field>
  </div>

  <div
    class="group-in-two-columns w-100"
    *ngIf="form.value.packingMethodSubType"
  >
    <mat-form-field>
      <app-easy-input
        [label]="TITLE + (isCollection ? 'UNIT_PER_COLLECTION' : 'NET_AMOUNT')"
        formControlName="amount"
        [min]="isCollection ? 1 : 0"
        [maxDecimals]="isCollection ? 0 : -1"
        type="number"
        [outerSuffixLabel]="
          isCollection ? ('PRODUCTS.UNIT.PIECES' | translate) : ''
        "
      >
      </app-easy-input>
    </mat-form-field>

    <mat-form-field *ngIf="!isCollection">
      <app-easy-select
        [label]="TITLE + 'UNIT'"
        formControlName="unit"
        [labelAttribute]="'name'"
        [valueAttribute]="'value'"
        [options]="units | toSelectOption: 'PRODUCTS.UNIT.'"
        [translatePrefixForSelected]="'PRODUCTS.UNIT.'"
        [hasEmptyOption]="false"
      >
      </app-easy-select>
    </mat-form-field>
  </div>
</fieldset>
